<!-- application-html -->
<div class="container-fluid">
  <div class="main-content">
    <b-row class="mb-3">
      <!-- Persistent MenuVoices -->
      <b-col cols="2">
        <SideMenu @menu-item-selected="handleMenuSelection"></SideMenu>
      </b-col>

      <!-- Dynamic Content -->
      <b-col cols="10">
        <div class="body-content">
          <router-view :key="$route.fullPath"></router-view>
        </div>
      </b-col>
    </b-row>
  </div>
</div>